import {fnToastrFormError, resetForm} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnVatDeadlinesTable = function () {

    var tableName = '#datatable-vat-deadlines';
    var modal = $('#modal-add-vat-deadline');

    if (!element_exists(tableName)) return false;

    $('#vat_deadlines_tab').click(function(){
        $(tableName).DataTable().ajax.reload(null, false);
    });

    $.fn.dataTable.moment( 'DD-MM-YY' );

    $('#datatable-vat-deadlines tbody').off('click', 'tr');
    $('#datatable-vat-deadlines tbody').on('click', 'tr', function () {

        var tableData = table.row(this).data();
        console.log(tableData);
        $('#vat_deadline_id').val(tableData.vat_deadline_id);
        $('#settlement_period').val(tableData.settlement_period);
        $("#period option").each(function () {
            if ($(this).html() == tableData.period) {
                $(this).prop("selected", true);
                return;
            }
        });
        var date = tableData.deadline;
        var dateArray = date.split('-');
        var newDate = '20'+dateArray[2]+'-'+dateArray[1]+'-'+dateArray[0];
        $('#deadline').val(newDate);
        $('#delete-vat-deadline').removeClass('hidden');
        $('#submit-vat-deadline').addClass('hidden');
        modal.modal('show');
    });

    $('#add-vat-deadline').on('click', function(){
        modal.modal('show');
        $('#delete-vat-deadline').addClass('hidden');
        $('#submit-vat-deadline').removeClass('hidden');
    });

    $('#add-vat-deadline-form').off('submit').on('submit', function(e) {
        e.preventDefault();

        var formData = new FormData($(this)[0]);

        $.ajax({
            type: 'POST',
            url: '/addVatDeadline',
            data: formData,
            success: function (response) {
                modal.modal('hide');
            },
            cache: false,
            processData: false,
            contentType: false,
            error: fnToastrFormError,
        })
    });

    modal.off().on('hidden.bs.modal', function () {
        resetForm($('#add-vat-deadline-form'));
        $(tableName).DataTable().ajax.reload(null, false);
    });

    var columns = [
        {data: 'period'},
        {data: 'settlement_period'},
        {data: 'deadline'}
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {className: "p-l-10", width: "33%", targets: 0},
        {className: "p-l-10", width: "33%", targets: 1},
        {className: "p-l-10", width: "33%", targets: 2}
    ];

    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');
    var table = $(tableName).DataTable({
        language: allLangFiles.datatables,
        ajax: {
            type: 'POST',
            url: '/getVatDeadlines',
        },
        columns: columns,
        columnDefs: columnDefs,
        destroy: true,
        scrollX: true,
        lengthMenu: [[-1, 10, 25, 50, 75, 100],[allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
        initComplete: function (settings, json) {
            table.draw();
        },
    });

    const { $filterButtons } = redesignDataTablesHeader(tableName, true, null);
    $filterButtons.prepend($('#add-vat-deadline'));

    $('#delete-vat-deadline').click(function(e) {
        e.preventDefault();

        var vat_deadline_id = $('#vat_deadline_id').val();

        $.ajax({
            type: 'POST',
            url: '/deleteVatDeadline',
            data: {
                vat_deadline_id: vat_deadline_id,
            },
            success: function (response) {
                $(tableName).DataTable().ajax.reload(null, false);
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });
};